import { Divider, Grid, Link, Box } from '@mui/material';
import { footerStyles } from './styles';
import { Link as RouterLink } from 'react-router-dom';
import { MenuWithChildren } from '../../types/menu';

interface FooterMenuListProps {
  menus: MenuWithChildren[];
}
export const FooterMenuList: React.FC<FooterMenuListProps> = ({ menus }) => {
  return menus.length > 0 ? (
    <>
      <Divider sx={footerStyles.menuContainer} />
      <Grid container rowSpacing={4} columnSpacing={2.5}>
        {menus.map((menu) => (
          <Grid key={menu.id} item xs={12} sm={6} md={4} lg={3}>
            <Box sx={footerStyles.parentMenu}>
              <Link
                variant="medium"
                component={RouterLink}
                sx={footerStyles.menu}
                fontWeight="Bold"
                underline="none"
                to={menu.link}
              >
                {menu.display_name}
              </Link>
            </Box>
            {menu.children && menu.children.length > 0 && (
              <Grid container direction="column" spacing={2}>
                {menu.children.map((childMenu) => (
                  <Grid item key={childMenu.id}>
                    <Link
                      variant="small"
                      component={RouterLink}
                      sx={footerStyles.menu}
                      underline="none"
                      to={childMenu.link}
                    >
                      {childMenu.display_name}
                    </Link>
                  </Grid>
                ))}
              </Grid>
            )}
          </Grid>
        ))}
      </Grid>
    </>
  ) : null;
};
